/**
 *
 * Asynchronously loads the component for Calibration
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Calibration = lazyLoad(
  () => import('./index'),
  module => module.Calibration,
);
